/**
 * variation-discount.js
 *
 * Updates the discount percentage and amount in real time when the customer
 * selects a product variation. Two elements are kept in sync:
 *   - .summary__discount            (inside .woocommerce-variation-price in the Underscore template)
 *   - .product-content__sale-flash  (the badge on the product image)
 *
 * WooCommerce completely re-renders the content of .woocommerce-variation on
 * every found_variation event. A MutationObserver on that element detects each
 * re-render and fills the freshly created .summary__discount immediately.
 * This is more reliable than setTimeout because it fires after every render,
 * however many times WooCommerce triggers internally.
 */
(function ($) {
	'use strict';

	$(document).ready(function () {
		var $form = $('form.variations_form');

		if (!$form.length) {
			return;
		}

		var currentVariationId = null;

		// MutationObserver watches .woocommerce-variation for template re-renders.
		// After each render a fresh .summary__discount exists inside
		// .woocommerce-variation-price — we fill it immediately.
		var singleVariation = document.querySelector('.woocommerce-variation.single_variation');
		if (singleVariation && window.MutationObserver) {
			var observer = new MutationObserver(function () {
				if (currentVariationId) {
					updateDiscount(currentVariationId);
				}
			});
			observer.observe(singleVariation, { childList: true });
		}

		$form
			.on('found_variation', function (event, variation) {
				currentVariationId = variation.variation_id;
				// Direct call as fallback in case the MutationObserver already fired.
				updateDiscount(currentVariationId);
			})
			// show_variation fires on .single_variation (bubbles to $form) AFTER
			// WooCommerce has called .html(template) and started slideDown.
			// variation data is passed directly, so no reliance on currentVariationId.
			// This is the most reliable hook for showing the discount on page load.
			.on('show_variation', function (event, variation) {
				if (variation && variation.variation_id) {
					currentVariationId = variation.variation_id;
					updateDiscount(variation.variation_id);
				}
			})
			.on('reset_data', function () {
				currentVariationId = null;
				clearDiscount();
			});

		// Initial state: WooCommerce may have already rendered the template
		// (for default attributes) before our script was loaded.
		setTimeout(function () {
			var initialId = parseInt($form.find('input[name="variation_id"]').val(), 10);
			if (initialId > 0) {
				currentVariationId = initialId;
				updateDiscount(initialId);
			}
		}, 0);
	});

	/**
	 * Update both discount elements for the given variation ID.
	 */
	function updateDiscount(variationId) {
		var discounts = (typeof ecsVariationDiscounts !== 'undefined') ? ecsVariationDiscounts : {};
		var data = discounts[variationId] || null;

		// --- summary__discount (inside .woocommerce-variation-price) ---
		var $discountBlock = $('.summary__discount');
		if (data) {
			$discountBlock
				.html(buildDiscountHtml(data.saving_price, data.saving_percentage))
				.show();
		} else {
			$discountBlock.hide();
		}

		// --- product-content__sale-flash (badge on product image) ---
		var $badge = $('.product-content__sale-flash');
		if (data) {
			$badge.find('.onsale__percentage').html(data.saving_percentage + '&percnt;');
			$badge.show();
		} else {
			$badge.hide();
		}
	}

	/**
	 * Build discount HTML from the PHP-localized template.
	 */
	function buildDiscountHtml(price, percentage) {
		var template = (typeof ecsDiscountTemplate !== 'undefined')
			? ecsDiscountTemplate
			: 'U bespaart <strong>{{price}}</strong> ({{percentage}}&percnt; korting)';

		return template
			.replace('{{price}}', price)
			.replace('{{percentage}}', percentage);
	}

	/**
	 * Hide both discount elements when no variant is selected.
	 */
	function clearDiscount() {
		$('.summary__discount').hide();
		$('.product-content__sale-flash').hide();
	}

}(jQuery));

